import { render, staticRenderFns } from "./Shell.vue?vue&type=template&id=56a0d39c&"
import script from "./Shell.vue?vue&type=script&lang=ts&"
export * from "./Shell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports